import React, { useState, useReducer, useEffect, Suspense } from "react"
import { useImmerReducer } from "use-immer"
import { BrowserRouter, Switch, Route } from "react-router-dom"
import "tachyons"
import StateContext from "./StateContext"
import DispatchContext from "./DispatchContext"
import { CSSTransition } from "react-transition-group"
//components
import Header from "./Header"
import Footer from "./Footer"
import Main from "./Main"
import About from "./About"
import Terms from "./Terms"
import EmptyFeed from "./EmptyFeed"

import Axios from "axios"

import FlashMessages from "./FlashMessages"
import Profile from "./Profile"
import EditPost from "./EditPost"
import NotFound from "./NotFound"

import LoadingDotsIcon from "./LoadingDotsIcon"

const CreatePost = React.lazy(() => import("./CreatePost"))
const ViewSinglePost = React.lazy(() => import("./ViewSinglePost"))
const Search = React.lazy(() => import("./Search"))
const Chat = React.lazy(() => import("./Chat"))

Axios.defaults.baseURL = process.env.BACKENDURL || "https://backendforteddaaapp.herokuapp.com"
const App = () => {
  const initialState = {
    loggedIn: Boolean(localStorage.getItem("teddaaappToken")),
    flashMessages: [],
    user: {
      token: localStorage.getItem("teddaaappToken"),
      username: localStorage.getItem("teddaaappUsername"),
      avatar: localStorage.getItem("teddaaappAvatar"),
    },
    isSearchOpen: false,
    isChatOpen: false,
    unreadChatCount: 0,
  }

  function ourReducer(draft, action) {
    switch (action.type) {
      case "login":
        draft.loggedIn = true
        draft.user = action.data
        break
      case "logout":
        draft.loggedIn = false
        break
      case "flashMessage":
        draft.flashMessages.push(action.value)
        break
      case "openSearch":
        draft.isSearchOpen = true
        break
      case "closeSearch":
        draft.isSearchOpen = false
        break
      case "toggleChat":
        draft.isChatOpen = !draft.isChatOpen
        break
      case "closeChat":
        draft.isChatOpen = false
        break
      case "incrementUnreadChatCount":
        draft.unreadChatCount++
        break
      case "clearUnreadChatCount":
        draft.unreadChatCount = 0
        break
    }
  }

  const [state, dispatch] = useImmerReducer(ourReducer, initialState)

  useEffect(() => {
    if (state.loggedIn) {
      localStorage.setItem("teddaaappToken", state.user.token)
      localStorage.setItem("teddaaappUsername", state.user.username)
      localStorage.setItem("teddaaappAvatar", state.user.avatar)
    } else {
      localStorage.removeItem("teddaaappToken", state.user.token)
      localStorage.removeItem("teddaaappUsername", state.user.username)
      localStorage.removeItem("teddaaappAvatar", state.user.avatar)
    }
  }, [state.loggedIn])

  //check if tokan has expired or not
  useEffect(() => {
    if (state.loggedIn) {
      //send axios request to get result
      const ourRequest = Axios.CancelToken.source()
      async function fetchResults() {
        try {
          const response = await Axios.post("/checkToken", { token: state.user.token }, { cancelToken: ourRequest.token })
          if (!response.data) {
            dispatch({ type: "logout" })
            dispatch({ type: "flashMessage", value: "Your session time has been expired please login again." })
          }
        } catch (e) {
          console.log("there was a dikkat.!!")
        }
      }
      fetchResults()
      return () => ourRequest.cancel
    }
  }, [state.requestCount])

  return (
    <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        <BrowserRouter>
          <FlashMessages messages={state.flashMessages} />
          <Header />
          <Suspense fallback={<LoadingDotsIcon />}>
            <Switch>
              <Route path="/profile/:username">
                <Profile />
              </Route>
              <Route path="/" exact>
                {state.loggedIn ? <EmptyFeed /> : <Main />}
              </Route>
              <Route path="/post/:id" exact>
                <ViewSinglePost />
              </Route>
              <Route path="/post/:id/edit" exact>
                <EditPost />
              </Route>
              <Route path="/create-post">
                <CreatePost />
              </Route>
              <Route path="/About-us">
                <About />
              </Route>
              <Route path="/Terms">
                <Terms />
              </Route>
              <Route>
                <NotFound />{" "}
              </Route>
            </Switch>
          </Suspense>
          <CSSTransition timeout={330} in={state.isSearchOpen} classNames="search-overlay" unmountOnExit>
            <div className="search-overlay">
              <Suspense fallback="">
                <Search />
              </Suspense>
            </div>
          </CSSTransition>
          <Suspense fallback="">{state.loggedIn && <Chat />}</Suspense>
          <Footer />
        </BrowserRouter>
      </DispatchContext.Provider>
    </StateContext.Provider>
  )
}

export default App
